import Annexure1 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-I.pdf";
import Annexure2 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-II.pdf";
import Annexure3 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-III.pdf";
import Annexure5 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-V.pdf";
import Annexure6 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-VI.pdf";
import Annexure9 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-IX.pdf";
import Annexure11 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-XI.pdf";
import Annexure14 from "../../assets/pdfs/muhs/Annexure_21-22/Annexure-XIV.pdf";
import { Box, Stack } from "@mui/material";
import AnnexureTabs from "../../components/muhsComponents/AnnexureTabs";
const annexures = [
  {
    name: "Annexure-I",
    link: Annexure1,
    content: "Seat Matrix",
  },
  {
    name: "Annexure-II",
    link: Annexure2,
    content: "Infrastructure Details",
  },
  {
    name: "Annexure-III",
    link: Annexure3,
    content: "Trust Deed/ By Laws/ Registration Certificate",
  },
  {
    name: "Annexure-V",
    link: Annexure5,
    content: "Clinical Material in Hospital",
  },
  {
    name: "Annexure-VI",
    link: Annexure6,
    content:
      "Details of Equipment and Instruments Required For Physiotherapy Laboratory as per MSR",
  },

  {
    name: "Annexure-IX",
    link: Annexure9,
    content:
      "Total Non-Teaching Staff & Ancillary Services Information as per MSR",
  },

  {
    name: "Annexure-XI",
    link: Annexure11,
    content: "Information of Workshops, Activities performed in last one year",
  },

  {
    name: "Annexure-XIV",
    link: Annexure14,
    content: "Declaration by the Dean/ Princiapl of the College/ Institute",
  },
];

const Muhs2021_22 = () => {
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90vw",
      }}
      m={2}
    >
      <Stack
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{
          border: "1px solid #e0e0e0",
          p: { xs: 1, md: 3 },
          overflow: "auto",
        }}
      >
        <AnnexureTabs annexures={annexures} />
      </Stack>
    </Box>
  );
};

export default Muhs2021_22;
